// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"73":"marketing/css/app","750":"platform/css/app","825":"marketing/css/vuesora"}[chunkId] + ".css";
};